module.exports = __webpack_public_path__ + "img/LATIN10_15.f67d5fa2.jpg";